import { render, staticRenderFns } from "./FeedfutureGaleriaModelos.vue?vue&type=template&id=960e6b02&"
import script from "./FeedfutureGaleriaModelos.vue?vue&type=script&lang=js&"
export * from "./FeedfutureGaleriaModelos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports